<template>
  <div class="container">
        <div class="aui-head-bg">
        <div class="row-end pt10 pr10">
            <a href="javascript:;">
                <i class="el-icon-s-comment color-white fs24" @click="gotomessageList"></i>
            </a>
        </div>
            <div class="center color-white">
                <div class="aui-pot-user">
                    <img :src="headimg" alt="">
                </div>
                <div>
                    <h3>{{name}} <i class="el-icon-edit color-white fs18 showMouse"></i></h3>
                    <div class="fs14 pb10">
                        <div>年龄：<em>18</em> | 城市：<em>北京</em></div>
                        <!-- <div class="mt5 pb10">简介：钟意你</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="mt15">
            <div v-for="(item,index) in personlist" :key="index" class="aui-resume-item mt10 pl10 pr10">
                <div class="row-spaceb b-line">
                        <div class="pt5 pb5 fs14">推荐</div>
                        <a href="javascript:;">
                            <i class="el-icon-s-comment fs24" @click="gotomessageDetail(item)"></i>
                        </a>
                </div>
                <div class="row-start">
                    <div class="aui-resume-user">
                        <img :src="item.image" alt="">
                        <!-- <i class="iconfont icon-nvsheng iconSize ml10" /> -->
                    </div>
                    <div class="aui-flex-box">
                        <h3>{{item.nickname}} <em> | 状态：{{item.status}}  </em></h3>
                        <!-- <h3><em>北京</em></h3> -->
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
import wxlogin from 'vue-wxlogin';
import { postAction, getAction } from '@/api/manage'
export default {
  components: { wxlogin },
  name: 'Login',
  data() {
    return {
     userInfo:{
         image:'',
         nickname:''
     },
     personlist:[

     ]
    }
  },
  computed:{
    userinfoLove() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getUserinfoLove || {};
    },
    openid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.jsopenid;
    },
    unionid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.unionid;
    },
    headimg() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.image;
    },
    name() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.nickname;
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
  },
  created () {
    this.gotoCode()
  },
  methods: {
     gotoCode(){
       if(!this.openid){
            if(!this.code){
                var url = encodeURIComponent(window.location.protocol+"//"+window.location.hostname+ '/personCenter')
                window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
            }else {
                this.getJsLogin()
            }
       }else {
         this.getPersonList()
       }
     },
    getJsLogin(){
        const url = '/user/jslogin'
            postAction(url, {code:this.code}).then( res => {
                if(res.data.code == 200){
                    this.userInfo = res.data.msg
                    this.$store.commit('setUserInfoLove', this.userInfo)
                    console.log('this.userInfo',this.userInfo,this.$store.getters)
                    this.getPersonList()
                } else if(res.data.code == 400) {
                    this.userInfo = res.data.msg
                    this.$store.commit('setUserInfoLove', this.userInfo)
                }
            })
    },
    gotomessageList(){
        this.$router.push({ name: 'MessageList'})
    },
    gotomessageDetail(param){
       this.$router.push({ name: 'MessageDetail', query: { username: param.openid,image:param.image } })
    },
    getPersonList(){
      const url = '/message/personList'
      postAction(url, {id:this.openid}).then( res => {
            this.personlist = res.data.msg
      })
    }
  }
}
</script>
<style scoped>

/* 必要布局样式css */

.aui-head-bg{
    background-image:url("../assets/head-bg.png");
    background-size:cover;
    width:100%;
}

.aui-pot-user{
    width:70px;
    height:70px;
    margin-right:1rem;
}


.aui-pot-user img{
    width:70px;
    height:70px;
    display:block;
    border:none;
    border-radius:100%;

}

.aui-resume-item{
    background:#fff;
    height:auto;
    border-radius:0.4rem;
    padding:0.5rem 1rem;
    margin-bottom:15px;
    overflow:hidden;
    border: 1px solid #e2e2e2;
}


.b-line {
    position: relative;
}

.b-line:after {
    content: '';
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #e2e2e2;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
}

.aui-resume-user{
    width:60px;
    margin-right:1rem;
}

.aui-resume-user img{
    width:100%;
    height:auto;
    display:block;
    border:none;
}

.icon-iphone{
    background-size:18px;
    width:18px;
    height:18px;
    margin-right:0.2rem;
    background-image:url('data:image/png;base64,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');
}
.icon-add{
    background-size:18px;
    width:18px;
    height:18px;
    margin-right:0.2rem;
    background-image:url('data:image/png;base64,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');

}
.aui-flex-box{
    text-align: left;
}
.aui-flex-box h3{
    color:#222222;
    font-size:0.9rem;
    margin-bottom:0.4rem;
}

.aui-flex-box h3 em{
    font-size:0.8rem;
    font-style:normal;
    font-weight:normal;
    color:#666666;
}

.aui-flex-box p{
    color:#252525;
    margin-bottom:0.4rem;
}

.aui-flex-box h4{
    height:22px;
    font-size:0.9rem;
    font-weight:normal;
    color:#696969;
}


</style>
